import { PRODUCT_TYPES } from '@src/quince-site-common/src/domains/Product/BundleProduct'
import PRODUCT_DOMAIN_TYPES from '@src/quince-site-common/src/domains/Product/ProductDomainTypes'
import ProductOptionValue, { ProductOption } from '@src/quince-site-common/src/domains/ProductOption'
import ProductTag from '@src/quince-site-common/src/domains/ProductTag'
import { PromoConfig } from '@src/quince-site-common/src/domains/ProductVariant/PromoConfig'

export interface IProductCard {
  product: IWebsiteProduct
}
export interface IWebsiteProduct {
  productId: number
  relatedIds: RelatedProductIds
  title: string
  slug: string
  type: PRODUCT_TYPES
  productDomainTypes: PRODUCT_DOMAIN_TYPES.WEBSITE_PRODUCT
  thirdPartyDetails: ThirdPartyDetails
  cardVariants: CardVariant[]
  totalCardVariants: number
  reviews: ProductCardReviewDetails
  flags: ProductCardFlags
  productTypeName: string
  classification?: {
    division: string
    division_id: number
    department: string
    department_id: number
    subdepartment: string
    subdepartment_id: number
  }
  colorVariants?: string[]
  customVariants: string[]
}

interface ProductCardFlags {
  quickBuyEnabled?: boolean // False for bundles
  wishlistEnabled?: boolean // False for bundles
  readyToShipEnabled?: boolean
  isWhiteGloveDeliveryAvailable?: boolean
}

interface RelatedProductIds {
  contentfulId: string
  shopifyId: number
}

interface ThirdPartyDetails {
  brand?: string
}

interface ProductCardOptionPrice {
  salePrice: number
  isRange: boolean
}

export interface ProductCardReviewDetails {
  averageRating: number
  ratingsTotal: number
  reviewCount: number
}

interface ProductCardImage {
  id: string
  url: string
  alt: string
  height: number
  description: string
  width: number
}

export interface TSocialProofData {
  stockTag?: string
  soldRecentlyTag?: string
}

export interface CardVariant {
  title: string
  displayConfig: ProductOptionValue & Pick<ProductOption, 'name'>
  variantId: number
  variantIds: number[]
  url: string

  price: ProductCardOptionPrice
  images: ProductCardImage[]

  // Variant level tags
  tags: ProductCardTag[]
  vendorType: string | number
  shopifyIds: number[]
  socialProofData: TSocialProofData
  promoConfig: PromoConfig[]
}

export type ProductCardTag = Pick<ProductTag, 'value' | 'tagType'>

export enum ProductTags {
  SOLD_OUT = 'Sold Out',
}
